import React from "react";
import {
  NavigationMenuList,
  NavigationMenuItem,
  NavigationMenuTrigger,
  NavigationMenuContent,
  NavigationMenuLink,
  navigationMenuTriggerStyle,
} from "../../../components/ui/navigationmenu";
import { navLinks } from "../../../components/layout/NavComponents/navLinks";
import { ListItem } from "../../../components/layout/NavComponents/ListItem";

export function NavbarDesktopMenu({ setIsDropdownOpen }) {
  return (
    <div className="hidden md:flex flex-1 justify-center">
      <NavigationMenuList className="gap-1">
        {navLinks.map((link) =>
          link.isDropdown ? (
            <NavigationMenuItem key={link.label} value={link.label}>
              <NavigationMenuTrigger
                onMouseEnter={() => setIsDropdownOpen?.(true)}
                onFocus={() => setIsDropdownOpen?.(true)}
                className="relative rounded-lg border border-transparent bg-transparent px-4 py-2 text-sm font-medium text-gray-300 transition-all duration-300 ease-out hover:border-white/[0.08] hover:bg-white/[0.06] hover:text-white focus:bg-white/[0.06] focus:text-white data-[state=open]:border-white/[0.08] data-[state=open]:bg-white/[0.08] data-[state=open]:text-white data-[state=open]:shadow-[0_0_30px_rgba(59,130,246,0.12)]"
              >
                {link.label}
              </NavigationMenuTrigger>

              <NavigationMenuContent
                onMouseEnter={() => setIsDropdownOpen?.(true)}
                onMouseLeave={() => setIsDropdownOpen?.(false)}
              >
                <div className="relative w-[900px] lg:w-[1000px]">
                  <div className="pointer-events-none absolute left-0 right-0 top-0 h-[1px] bg-gradient-to-r from-transparent via-blue-500/60 to-transparent" />
                  <div className="pointer-events-none absolute -top-10 left-1/2 h-20 w-96 -translate-x-1/2 rounded-full bg-blue-600/20 blur-[60px]" />

                  <ul className="grid grid-cols-4 gap-4 overflow-hidden rounded-xl border border-white/[0.08] bg-slate-950/95 p-4 shadow-2xl shadow-black/60 backdrop-blur-2xl">
                    {link.dropdownContent.map((item) => (
                      <ListItem
                        key={item.title}
                        title={item.title}
                        href={item.href}
                        icon={item.icon}
                        className="group relative flex flex-col items-start gap-2 rounded-xl border border-transparent px-4 py-4 text-sm transition-colors duration-200 hover:border-white/[0.05] hover:bg-white/[0.04]"
                      >
                        <div className="absolute left-0 top-1/2 h-0 w-[2px] -translate-y-1/2 rounded-r-full bg-blue-500 transition-all duration-300 group-hover:h-8" />

                        <div className="flex items-center gap-3">
                          <item.icon className="h-6 w-6 text-blue-400" />
                          <span className="font-semibold text-gray-100">
                            {item.title}
                          </span>
                        </div>
                        <span className="mt-1 text-xs text-gray-400">
                          {item.description}
                        </span>
                      </ListItem>
                    ))}
                  </ul>
                </div>
              </NavigationMenuContent>
            </NavigationMenuItem>
          ) : (
            <NavigationMenuItem key={link.label}>
              <NavigationMenuLink asChild>
                <a
                  href={link.href}
                  className={
                    navigationMenuTriggerStyle() +
                    " rounded-lg border border-transparent bg-transparent px-4 py-2 text-sm font-medium text-gray-300 transition-all duration-300 hover:border-white/[0.08] hover:bg-white/[0.06] hover:text-white focus:bg-white/[0.06] focus:text-white"
                  }
                >
                  {link.label}
                </a>
              </NavigationMenuLink>
            </NavigationMenuItem>
          )
        )}
      </NavigationMenuList>
    </div>
  );
}
